var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_expand_menu",
    "data-name": "icon expand menu",
    className: "cls-1",
    d: "M7.727,12.744l5-5.244-5-5.243L9.865,0,17,7.5,14.863,9.756,9.865,15ZM0,12.744,5,7.5,0,2.256,2.138,0,9.273,7.5,7.135,9.756,2.138,15Z",
    transform: "translate(17 15) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCollapsed);
export default __webpack_public_path__ + "static/media/menu_collapsed.37baa3650028a0ff6817bc3776f0a3ba.svg";
export { ForwardRef as ReactComponent };